import { render, staticRenderFns } from "./WLogoOrsai.vue?vue&type=template&id=142da10a&"
import script from "./WLogoOrsai.vue?vue&type=script&lang=js&"
export * from "./WLogoOrsai.vue?vue&type=script&lang=js&"
import style0 from "./WLogoOrsai.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports